<div *ngIf="part === 1">
    <p>
      Du möchtest zwischendurch etwas <span class="highlight">ANDERES</span> machen?
    </p>
    <p>
      Kein Problem! Dein Stand wird
      automatisch gespeichert.
    </p>
</div>
<div *ngIf="part === 2">
  <p>
    Du warst zu <span class="highlight">SCHNELL</span>?</p>
    <p>
    Tippe auf den Pfeil nach links,<br>
   um zur letzten Aussage zurückzukommen.
  </p>
</div>
<div *ngIf="part === 3">
  <p>
    Im Menü unter <ion-icon style="display:inline-block; vertical-align: text-bottom;" name="globe-outline" color="dark"></ion-icon> “Nützliche Links”
    findest Du nützliche <span class="highlight">VERLINKUNGEN</span> zu weiteren Informationsseiten.
  </p>
</div>
<div *ngIf="part === 4">
<p>
  Du möchtest Dir während des Erwartungschecks die <span class="highlight">TIPPS</span> noch einmal ansehen?</p>
  <p>
Dann klicke im Menü auf <ion-icon name="bulb-outline" color="dark"></ion-icon>.
</p>
</div>


